<template>
  <div>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               ref="crud"
               v-model="form"
               :permission="permissionList"
               :before-open="beforeOpen"
               :page.sync="page"
               @search-change="searchChange"
               @search-reset="searchReset"
               @current-change="currentChange"
               @size-change="sizeChange"
               @refresh-change="refreshChange"
               @on-load="onLoad">
    </avue-crud>
  </div>
</template>

<script>
import { getApiList, getApiLogs } from "@/api/logs";
import { mapGetters } from "vuex";
import crudmixins from "@/basic-common/mixins/crudmixins.js";
import {removePercent} from "@/util/util";

const mixin = new crudmixins({})

export default {
  mixins: [mixin],
  data() {
    return {
      form: {},
      selectionList: [],
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 8,
        searchSpan: 8,
        border: true,
        index: true,
        viewBtn: true,
        editBtn: false,
        addBtn: false,
        delBtn: false,
        menuWidth: 120,
        dialogType: 'drawer',
        searchDateProp: { startTime: 'searchDate', type: 'day' },
        column: [
          {
            label: "服务端ID",
            prop: "serviceId",
            width: '80',
            search: true,
            overHidden: true
          },
          {
            label: "服务端名",
            prop: "serverHost",
            search: true,
            overHidden: true
          },
          {
            label: "服务端IP",
            prop: "serverIp",
            overHidden: true
          },
          {
            label: "客户端IP",
            prop: "remoteIp",
            overHidden: true
          },
          {
            label: "软件环境",
            prop: "env",
            width: '80',
            overHidden: true
          },
          {
            label: "日志名",
            prop: "title",
            overHidden: true
          },
          {
            label: "请求方法",
            prop: "method",
            width: '80',
            overHidden: true
          },
          {
            label: "请求接口",
            prop: "requestUri",
            overHidden: true
          },
          {
            label: "日志时间",
            prop: "createTime",
            width: '180',
            overHidden: true
          },
          {
            label: "用户代理",
            prop: "userAgent",
            span: 24,
            hide: true,
            overHidden: true
          },
          {
            label: "请求数据",
            prop: "params",
            type: "textarea",
            span: 24,
            minRows: 2,
            hide: true
          },
          {
            label: "日志时间",
            prop: "searchDate",
            type: "datetime",
            dataType: 'string',
            search: true,
            hide: true,
            showColumn: false,
            searchValue: "",
            dateDefault: true,
            overHidden: true,
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            searchRange: true,
            viewDisplay: false,
          }
        ]
      },
      data: []
    };
  },

  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        viewBtn: this.vaildData(this.permission.log_api_view, false),
        form: {},
        selectionList: [],
        query: {},
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        option: {
          height: 'auto',
          calcHeight: 30,
          tip: false,
          searchShow: true,
          searchMenuSpan: 6,
          border: true,
          index: true,
          viewBtn: true,
          editBtn: false,
          addBtn: false,
          delBtn: false,
          menuWidth: 120,
          dialogType: 'drawer',
          overHidden: true,
          column: [
            {
              label: "服务id",
              prop: "serviceId",
              width: '120',
              search: true,
              overHidden: true
            },
            {
              label: "服务host",
              prop: "serverHost",
              search: true,
              overHidden: true
            },
            {
              label: "服务ip",
              prop: "serverIp",
              width: '160',
              overHidden: true
            },
            {
              label: "请求ip",
              prop: "remoteIp",
              overHidden: true
            },
            {
              label: "软件环境",
              prop: "env",
              width: '80',
              overHidden: true
            },
            {
              label: "日志名",
              prop: "title",
              overHidden: true
            },
            {
              label: "请求方法",
              prop: "method",
              width: '80',
              overHidden: true
            },
            {
              label: "请求接口",
              prop: "requestUri",
              overHidden: true
            },
            {
              label: "日志时间",
              prop: "createTime",
              width: '180',
              overHidden: true
            },
            {
              label: "用户代理",
              prop: "userAgent",
              span: 24,
              hide: true,
              overHidden: true
            },
            {
              label: "请求数据",
              prop: "params",
              type: "textarea",
              span: 24,
              minRows: 2,
              hide: true,
              overHidden: true
            },
            {
              label: "查询时间",
              prop: "searchDate",
              type: "datetime",
              dataType: 'string',
              hide: true,
              showColumn: false,
              search: true,
              addDisplay: false,
              editDisplay: false,
              viewDisplay: false,
              dateDefault: true,
              overHidden: true,
              searchRange: true,
              format: "yyyy-MM-dd HH:mm:ss",
              valueFormat: "yyyy-MM-dd HH:mm:ss",
            }
          ]
        },
        data: []
      };
    }
  },
  methods: {
    searchReset() {
      this.query = {};
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    beforeOpen(done, type) {
      if (["edit", "view"].includes(type)) {
        getApiLogs(this.form.id).then(res => {
          this.form = res.data.data;
        });
      }
      done();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad(page, params = {}) {
      this.loading = true;
      // 去除参数%
      params = removePercent(params)
      getApiList(page.currentPage, page.pageSize, Object.assign(params, this.query)).then(res => {
        const data = res.data.data;
        this.page.total = data.total;
        this.data = data.records;
        this.loading = false;
      });
    }
  }
};
</script>

<style>
</style>
